import React from 'react';
import { CircularProgress, TableRow } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { StyledTableCellProps as StyledTableCell } from '../utils/TableStyles';

/**
 * Las filas que ocupan la tabla entera cuando no hay datos que mostrar: la de "cargando" y la
 * de "sin resultados".
 *
 * EL `colSpan` ES EL PUNTO. La fila de loading está en 32 grillas con un número escrito a mano
 * —23 usan `colSpan={14}`, y tickets pone 13 teniendo 38 columnas— que nadie actualiza cuando
 * la grilla cambia. Con un número menor que la cantidad de columnas, el spinner no queda
 * centrado y la tabla dibuja celdas vacías al costado. Acá se pasa la cantidad real, que la
 * grilla ya conoce: con `useColumnVisibility`, es cuántas columnas se están viendo.
 *
 *     <GridLoadingRow visible={loading} columns={columnasALaVista} />
 */

const FilaCompleta = (props) => (
	<TableRow>
		<StyledTableCell colSpan={props.columns || 1} align="center">
			{props.children}
		</StyledTableCell>
	</TableRow>
);

export const GridLoadingRow = (props) => {
	if (props.visible === false) return null;

	return (
		<FilaCompleta columns={props.columns}>
			<CircularProgress />
		</FilaCompleta>
	);
};

/**
 * "Sin resultados". Hoy **49 de las 52 grillas no muestran nada** cuando la búsqueda no trae
 * filas: la tabla queda con el encabezado y el cuerpo en blanco, que se confunde con un error.
 * El componente existe para cuando esa decisión de producto se tome; no se adopta solo.
 */
export const GridEmptyRow = (props) => {
	if (props.visible === false) return null;

	return (
		<FilaCompleta columns={props.columns}>
			{props.children ? (
				props.children
			) : (
				<FormattedMessage
					id={props.messageId || 'grid.sin_resultados'}
					defaultMessage={props.label || 'No se encontraron resultados'}
				/>
			)}
		</FilaCompleta>
	);
};

export default GridLoadingRow;
